(function () {
  // Keeps the cart disclosure hover tooltip within the viewport.
  // On hover we measure the tooltip and set a `--cart-disclosure-tooltip-shift`
  // custom property that nudges it back into view;
  // the arrow is counter-shifted in CSS so it keeps pointing at the icon.
  const VIEWPORT_MARGIN = 16;

  function positionTooltip(button) {
    const tooltip = button.querySelector('.cart-item__disclosure-tooltip');
    if (!tooltip) return;

    // Reset before measuring so we read the natural, centered position.
    tooltip.style.setProperty('--cart-disclosure-tooltip-shift', '0px');

    const rect = tooltip.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    let shift = 0;

    if (rect.right > viewportWidth - VIEWPORT_MARGIN) {
      shift = viewportWidth - VIEWPORT_MARGIN - rect.right;
    } else if (rect.left < VIEWPORT_MARGIN) {
      shift = VIEWPORT_MARGIN - rect.left;
    }

    tooltip.style.setProperty('--cart-disclosure-tooltip-shift', `${Math.round(shift)}px`);
  }

  function onPointerOver(event) {
    const button = event.target.closest?.('.cart-item__disclosure');
    if (!button || button.dataset.tooltipPositioned === 'true') return;

    button.dataset.tooltipPositioned = 'true';
    positionTooltip(button);
  }

  function onPointerOut(event) {
    const button = event.target.closest?.('.cart-item__disclosure');
    if (button && !button.contains(event.relatedTarget)) {
      delete button.dataset.tooltipPositioned;
    }
  }

  document.addEventListener('pointerover', onPointerOver);
  document.addEventListener('pointerout', onPointerOut);
})();

/* Mama Wynja: clean internal English links on the English storefront.
   This keeps hard-coded page/article links on translated pages inside the English URL structure. */
(function () {
  const lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (!lang.startsWith('en')) return;

  const localePrefix = window.location.pathname.startsWith('/en/') ? '/en' : '';

  const replacements = new Map([
    ['/pages/ritualer', '/pages/rituals'],
    ['/pages/shoppa', '/pages/shop'],
    ['/pages/intentioner', '/pages/intentions'],
    ['/pages/kopparbergs-marknad', '/pages/kopparberg-market'],
    ['/pages/kontakt', '/pages/contact'],
    ['/pages/rena-hemmet', '/pages/cleanse-the-home'],
    ['/pages/lugn-kvall', '/pages/calm-evening'],
    ['/pages/sjalvkarlek', '/pages/self-love'],
    ['/pages/satt-nagot-i-rorelse', '/pages/set-something-in-motion'],
    ['/pages/lyssna-inat', '/pages/listen-within'],
    ['/pages/landa-har', '/pages/ground-here'],
    ['/pages/mitt-ja-mitt-nej', '/pages/my-yes-my-no'],
    ['/pages/lat-gladjen-stanna', '/pages/let-joy-stay'],
    ['/blogs/wynjas-visdom', '/blogs/wynjas-wisdom'],
    ['/blogs/wynjas-wisdom/7-ritualer-for-sjalvkarlek-sa-lar-du-dig-alska-dig-sjalv', '/blogs/wynjas-wisdom/self-love-is-a-verb-7-everyday-rituals'],
    ['/blogs/wynjas-wisdom/rena-hemmet-ritual-nystart', '/blogs/wynjas-wisdom/cleanse-the-home-ritual-presence-new-beginning'],
    ['/blogs/wynjas-wisdom/lugn-kvall-ritual-komma-hem-till-sig-sjalv', '/blogs/wynjas-wisdom/calm-evening-ritual-coming-home-to-yourself'],
    ['/blogs/wynjas-wisdom/nar-nagot-star-still-forsta-steget', '/blogs/wynjas-wisdom/when-something-stands-still-first-step'],
    ['/blogs/wynjas-wisdom/intuition-utan-facit-lyssna-inat', '/blogs/wynjas-wisdom/intuition-without-final-answers-listen-within'],
    ['/blogs/wynjas-wisdom/jorda-dig-sinnen-narvaro', '/blogs/wynjas-wisdom/grounding-senses-presence'],
    ['/blogs/wynjas-wisdom/gransen-som-omsorg-saga-nej', '/blogs/wynjas-wisdom/the-boundary-as-care-saying-no'],
    ['/blogs/wynjas-wisdom/gladjen-som-far-stanna-kvar', '/blogs/wynjas-wisdom/the-joy-that-gets-to-stay']
  ]);

  function normalizedPath(pathname) {
    return pathname.startsWith('/en/') ? pathname.slice(3) : pathname;
  }

  function cleanPath(pathname) {
    const bare = normalizedPath(pathname);
    const replacement = replacements.get(bare);
    if (!replacement) return null;
    return localePrefix + replacement;
  }

  function rewriteLinks(root = document) {
    root.querySelectorAll?.('a[href]').forEach((link) => {
      const raw = link.getAttribute('href');
      if (!raw || raw.startsWith('#') || raw.startsWith('mailto:') || raw.startsWith('tel:')) return;

      let url;
      try {
        url = new URL(raw, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin) return;

      const nextPath = cleanPath(url.pathname);
      if (!nextPath) return;

      link.setAttribute('href', nextPath + url.search + url.hash);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => rewriteLinks(), { once: true });
  } else {
    rewriteLinks();
  }

  const main = document.getElementById('MainContent') || document.body;
  if (main) {
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) rewriteLinks(node);
        });
      });
    }).observe(main, { childList: true, subtree: true });
  }
})();
